import {NgModule} from '@angular/core';
import {CommonModule, CurrencyPipe, DatePipe} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import { QuillModule } from 'ngx-quill';

import {MaterialModule} from '../material.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgxDaterangepickerMd} from 'ngx-daterangepicker-material';
import {AppDateRangeComponent} from './components/app-date-range/app-date-range.component';
import {AppPopoverComponent} from './components/app-popover/app-popover.component';
import {HoverDirective} from './components/app-popover/toggle-popover.directive';
import {SelectSearchDropdownComponent} from './components/select-search-dropdown/select-search-dropdown.component';
import {FileUploaderComponent} from './components/file-uploader/file-uploader.component';
import {DndDirective} from './directives/dnd.directive';
import {AppInputFormComponent} from './components/app-input-form/app-input-form.component';
import {AccordionComponent} from './components/accordion/accordion.component';
import {TooltipDirective} from './directives/tooltip.directive';
import {FileDownloaderComponent} from './components/file-downloader/file-downloader.component';
import {CheckboxComponent} from './components/checkbox/checkbox.component';
import {RadioGroupComponent} from './components/radio-group/radio-group.component';
import {AppDatePickerComponent} from './components/app-date-picker/app-date-picker.component';
import {DatePickerHeaderComponent} from './components/app-date-picker/date-picker-header/date-picker-header.component';
import {AppCurrencyInputComponent} from './components/app-currency-input/app-currency-input.component';
import {InputSearchComponent} from './components/input-search/input-search.component';
import {SystemMessageComponent} from './components/system-message/system-message.component';
import {ButtonDropdownComponent} from './components/button-dropdown/button-dropdown.component';
import {MoreDetailsLinkComponent} from './components/more-details-link/more-details-link.component';
import {AutonumericModule} from '@angularfy/autonumeric';
import {AutonumericDirective} from './directives/autonumeric.directive';
import {InputSearchDropdownComponent} from './components/input-search-dropdown/input-search-dropdown.component';
import {AppSelectFormComponent} from './components/app-select-form/app-select-form.component';
import {FileSelectorComponent} from './components/file-selector/file-selector.component';
import {UserPermissionsDirective} from './directives/user-permissions.directive';
import {AppTextareaFormComponent} from './components/app-textarea-form/app-textarea-form.component';
import {MultiSelectSearchDropdownComponent} from './components/multiselect-search-dropdown/multiselect-search-dropdown.component';
import {OverlayModule} from '@angular/cdk/overlay';
import {ClickNoSelectionDirective} from './directives/click-no-selection.directive';
import {RadioGroupFormComponent} from './components/radio-group-form/radio-group-form.component';
import {ApprovalManagerComponent} from './components/approval-manager/approval-manager/approval-manager.component';
import {PdfViewerComponent} from './components/approval-manager/pdf-viewer/pdf-viewer.component';
import {AppInputComponent} from './components/app-input/app-input.component';
import {AppArtworkItemComponent} from './components/app-artwork-item/app-artwork-item.component';
import {ArtworkItemStatusHeaderComponent} from './components/app-artwork-item/artwork-item-status-header/artwork-item-status-header.component';
import {AppDesignerAssignmentComponent} from './components/app-designer-assignment/app-designer-assignment.component';
import {TableComponent} from './components/table/table.component';
import {FileUploadProgressComponent} from './components/file-upload-progress/file-upload-progress.component';
import { OverlayscrollbarsModule } from 'overlayscrollbars-ngx';
import { InputChipsComponent } from './components/input-chips/input-chips.component';
import {ToastrModule} from 'ngx-toastr';
import { BackLinkComponent } from './components/back-link/back-link.component';
import { AppPercentInputComponent } from './components/app-percent-input/app-percent-input.component';
import { FilesApproveComponent } from './components/files-approve/files-approve.component';
import { ClickPreventDefaultDirective } from './directives/click-prevent-default.directive';
import { ClickStopPropagationDirective } from './directives/click-stop-propagation.directive';
import { AppInterceptableRadioGroupDirective } from './directives/interceptable-radio-group.directive';
import { RadioGroupFormConfirmComponent } from './components/radio-group-form-confirm/radio-group-form-confirm.component';
import { CustomHintDirective } from './directives/custom-hint.directive';
import { UserAssignmentComponent } from './components/app-user-assignment/app-user-assignment.component';
import { UserPermissionsV2Directive } from './directives/user-permissions-v2.directive';
import { EasyAriaDirective } from './directives/easy-aria.directive';
import { ArtworkItemCollapsibleComponent } from './components/app-artwork-item/artwork-item-collapsible/artwork-item-collapsible.component';
import { TruncateMiddleComponent } from './components/shared/components/truncate-middle/truncate-middle.component';
import { ObserversModule } from '@angular/cdk/observers';
import { CommonDirectivesModule } from './pipes/directives.module';
import { LazyComponent } from './components/app-lazy-component/lazy-component.component';
import { BulkChangeFileUploadComponent } from './components/bulk-change-file-upload/bulk-change-file-upload.component';

@NgModule({
  declarations: [
    AppDateRangeComponent,
    AppPopoverComponent,
    HoverDirective,
    SelectSearchDropdownComponent,
    MultiSelectSearchDropdownComponent,
    FileUploaderComponent,
    FileSelectorComponent,
    BulkChangeFileUploadComponent,
    DndDirective,
    AppInputFormComponent,
    AccordionComponent,
    TooltipDirective,
    FileDownloaderComponent,
    CheckboxComponent,
    RadioGroupComponent,
    AppDatePickerComponent,
    DatePickerHeaderComponent,
    AppCurrencyInputComponent,
    InputSearchComponent,
    SystemMessageComponent,
    ButtonDropdownComponent,
    MoreDetailsLinkComponent,
    AutonumericDirective,
    MoreDetailsLinkComponent,
    InputSearchDropdownComponent,
    AppSelectFormComponent,
    UserPermissionsDirective,
    UserPermissionsV2Directive,
    AppTextareaFormComponent,
    ClickNoSelectionDirective,
    ClickPreventDefaultDirective,
    ClickStopPropagationDirective,
    RadioGroupFormComponent,
    RadioGroupFormConfirmComponent,
    ApprovalManagerComponent,
    PdfViewerComponent,
    AppInputComponent,
    ArtworkItemStatusHeaderComponent,
    AppArtworkItemComponent,
    AppDesignerAssignmentComponent,
    UserAssignmentComponent,
    TableComponent,
    FileUploadProgressComponent,
    InputChipsComponent,
    BackLinkComponent,
    AppPercentInputComponent,
    FilesApproveComponent,
    AppInterceptableRadioGroupDirective,
    CustomHintDirective,
    EasyAriaDirective,
    ArtworkItemCollapsibleComponent,
    TruncateMiddleComponent,
    LazyComponent,
  ],
  imports: [
    CommonModule,
    ObserversModule,
    MaterialModule,
    AutonumericModule.forRoot(),
    NgxMatSelectSearchModule,
    TranslateModule,
    ReactiveFormsModule,
    NgxDaterangepickerMd.forRoot(),
    FormsModule,
    OverlayModule,
    OverlayscrollbarsModule,
    ToastrModule.forRoot(),
    RouterModule,
    QuillModule.forRoot({
      customOptions: [
        {
          import: 'attributors/style/size',
          whitelist: ['0.75em', '1.125em', '1.5em', '2.5em']
        }
      ]
    }),
    CommonDirectivesModule
  ],
  exports: [
    CommonModule,
    CommonDirectivesModule,
    MaterialModule,
    ObserversModule,
    TranslateModule,
    AppInputFormComponent,
    AppDateRangeComponent,
    AppPopoverComponent,
    HoverDirective,
    SelectSearchDropdownComponent,
    MultiSelectSearchDropdownComponent,
    FileUploaderComponent,
    FileSelectorComponent,
    BulkChangeFileUploadComponent,
    DndDirective,
    AccordionComponent,
    TooltipDirective,
    FileDownloaderComponent,
    CheckboxComponent,
    ReactiveFormsModule,
    RadioGroupComponent,
    AppDatePickerComponent,
    DatePickerHeaderComponent,
    AppCurrencyInputComponent,
    InputSearchComponent,
    ButtonDropdownComponent,
    MoreDetailsLinkComponent,
    InputSearchDropdownComponent,
    AppSelectFormComponent,
    UserPermissionsDirective,
    UserPermissionsV2Directive,
    AppTextareaFormComponent,
    ClickNoSelectionDirective,
    ClickPreventDefaultDirective,
    ClickStopPropagationDirective,
    RadioGroupFormComponent,
    RadioGroupFormConfirmComponent,
    AppInputComponent,
    DatePipe,
    PdfViewerComponent,
    ArtworkItemStatusHeaderComponent,
    AppArtworkItemComponent,
    AppDesignerAssignmentComponent,
    TableComponent,
    OverlayscrollbarsModule,
    InputChipsComponent,
    BackLinkComponent,
    AppPercentInputComponent,
    FilesApproveComponent,
    AutonumericDirective,
    AppInterceptableRadioGroupDirective,
    CustomHintDirective,
    UserAssignmentComponent,
    EasyAriaDirective,
    ArtworkItemCollapsibleComponent,
    TruncateMiddleComponent,
    LazyComponent,
  ],
  providers: [
    CurrencyPipe,
  ]
})
export class SharedModule { }
